import Button from '@carvana/ds-button';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useConfiguration } from '~/context/common/StaticContext';
import useIsSavedSearchApplied from '~/hooks/srp/useIsSavedSearchApplied';
import useLogInAndSaveSearch from '~/hooks/srp/useLogInAndSaveSearch';
import {
  Heading,
  LowResultWrapper,
  Subtitle
} from './SimilarResults/SimilarResultSection.styles';
import SimilarResultsSection from './SimilarResults/SimilarResultsSection';

export default function LowResultSection() {
  const { shouldUseTitleCasing } = useConfiguration();
  const handleSaveSearch = useLogInAndSaveSearch();
  const trackEvent = useTrackEvent();
  const savedSearchIsApplied = useIsSavedSearchApplied();

  useEffect(() => {
    trackEvent('Low Results Shown');

    datadogRum.addAction('Low Results Shown');
  }, [trackEvent]);

  return (
    <>
      {savedSearchIsApplied ? null : (
        <LowResultWrapper>
          <div className="flex flex-col items-center gap-lg">
            <Heading role="heading">We didn’t find many matches</Heading>
            <Subtitle>
              We get more cars every day. Get vehicles you’re looking for,
              straight to your inbox!
            </Subtitle>
          </div>

          <Button
            variant="primary"
            size="md"
            onClick={handleSaveSearch}
            data-adobe-id={null}
            data-analytics-id="create-search-alert-lrp"
            data-testid="save-search-low-results"
            className="w-full sm:w-fit"
          >
            {shouldUseTitleCasing ? 'Save This Search' : 'Save this search'}
          </Button>
        </LowResultWrapper>
      )}
      <hr className="-mx-2xl my-4xl border-t border-border-subtle sm:-mx-3xl md:mx-0 md:my-7xl" />
      <SimilarResultsSection />
    </>
  );
}
